export default __webpack_public_path__ + "static/media/play.b5855583.svg";